'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isChatRichTemplateMessage = require('conversations-schema/pubnub-message/operators/isChatRichTemplateMessage');

var _isPublished = require('conversations-schema/pubnub-message/operators/isPublished');

var _isFromVisitor = require('conversations-schema/pubnub-message/operators/isFromVisitor');

var _fileAttachmentIdsInMessage = require('conversations-schema/pubnub-message/operators/fileAttachmentIdsInMessage');

var _resolvedAttachmentGetters = require('conversations-schema/resolved-attachment/operators/resolvedAttachmentGetters');

var _fileMetadataGetters = require('conversations-schema/file-metadata/operators/fileMetadataGetters');

var _displayName = require('conversations-schema/file-metadata/operators/displayName');

var _ChatBubble = require('ui-addon-messages/chat-message/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _ChatRichTemplate = require('./ChatRichTemplate');

var _ChatRichTemplate2 = _interopRequireDefault(_ChatRichTemplate);

var _MessageFooter = require('./MessageFooter');

var _MessageFooter2 = _interopRequireDefault(_MessageFooter);

var _ChatMessageAvatar = require('./ChatMessageAvatar');

var _ChatMessageAvatar2 = _interopRequireDefault(_ChatMessageAvatar);

var _MessageWrapper = require('./MessageWrapper');

var _MessageWrapper2 = _interopRequireDefault(_MessageWrapper);

var _ChatMessageText = require('./ChatMessageText');

var _ChatMessageText2 = _interopRequireDefault(_ChatMessageText);

var _VisitorWidgetFileAttachment = require('./attachments/VisitorWidgetFileAttachment');

var _VisitorWidgetFileAttachment2 = _interopRequireDefault(_VisitorWidgetFileAttachment);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'VisitorChatMessage',

  propTypes: {
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    currentRole: _SenderTypePropType2.default.isRequired,
    fileAttachment: (0, _RecordPropType2.default)('ResolvedAttachmentRecord'),
    hideLabels: _react.PropTypes.bool,
    isFirstInGroup: _react.PropTypes.bool,
    isLastInGroup: _react.PropTypes.bool,
    message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
    messageRole: _SenderTypePropType2.default.isRequired,
    nextMessage: (0, _RecordPropType2.default)('PubNubMessageRecord'),
    onAttachmentClick: _react.PropTypes.func.isRequired,
    onAttachmentLoad: _react.PropTypes.func.isRequired,
    publishMessage: _react.PropTypes.func,
    quickReplyDisabled: _react.PropTypes.bool,
    republishMessage: _react.PropTypes.func,
    responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
    showFooterContent: _react.PropTypes.bool
  },

  mixins: [_react2.default.addons.PureRenderMixin],

  getDefaultProps: function getDefaultProps() {
    return {
      onAttachmentClick: function onAttachmentClick() {}
    };
  },
  isOwnMessage: function isOwnMessage() {
    var messageRole = this.props.messageRole;

    return messageRole === _senderTypes.VISITOR;
  },
  getTooltipPlacement: function getTooltipPlacement() {
    return this.isOwnMessage() ? 'right' : 'left';
  },
  renderAvatar: function renderAvatar() {
    return _react2.default.createElement(_ChatMessageAvatar2.default, {
      currentRole: this.props.currentRole,
      isLastInGroup: this.props.isLastInGroup,
      messageRole: this.props.messageRole,
      responder: this.props.responder,
      tooltipPlacement: this.getTooltipPlacement()
    });
  },
  renderAttachment: function renderAttachment() {
    var _this = this;

    var fileAttachmentIds = (0, _fileAttachmentIdsInMessage.fileAttachmentIdsInMessage)(this.props.message);

    if (!fileAttachmentIds || !fileAttachmentIds.size) {
      return null;
    }

    var attachmentFileMetadata = (0, _resolvedAttachmentGetters.getFileMetadata)(this.props.fileAttachment);
    var loading = !attachmentFileMetadata;

    return _react2.default.createElement(_VisitorWidgetFileAttachment2.default, {
      className: 'm-y-2',
      loading: loading,
      name: (0, _displayName.displayName)(attachmentFileMetadata),
      onClick: function onClick() {
        if (loading) {
          return;
        }

        _this.props.onAttachmentClick({
          attachment: _this.props.fileAttachment
        });
      },
      onLoad: this.props.onAttachmentLoad,
      size: (0, _fileMetadataGetters.getSize)(attachmentFileMetadata),
      type: (0, _fileMetadataGetters.getType)(attachmentFileMetadata),
      url: (0, _fileMetadataGetters.getUrl)(attachmentFileMetadata)
    });
  },
  renderChatBubble: function renderChatBubble() {
    var _props = this.props,
        message = _props.message,
        coloring = _props.coloring;


    if ((0, _isChatRichTemplateMessage.isChatRichTemplateMessage)(message)) {
      return _react2.default.createElement(_ChatRichTemplate2.default, { message: message });
    }

    var align = this.isOwnMessage() ? _ChatBubble.alignment.RIGHT : _ChatBubble.alignment.LEFT;

    var backgroundColor = (0, _isFromVisitor.isFromVisitor)(message) ? coloring.accentColor : undefined;
    var color = (0, _isFromVisitor.isFromVisitor)(message) ? coloring.textColor : undefined;

    return _react2.default.createElement(
      _ChatBubble2.default,
      {
        className: (0, _classNames2.default)('visitor-chat-bubble', {
          sent: (0, _isPublished.isPublished)(message),
          offline: (0, _messageTypeComparators.isOfflineMessage)(message)
        }),
        backgroundColor: backgroundColor,
        color: color,
        align: align,
        use: _ChatBubble.uses.DEFAULT,
        isFirstInGroup: this.props.isFirstInGroup,
        isLastInGroup: this.props.isLastInGroup
      },
      this.renderAttachment(),
      _react2.default.createElement(_ChatMessageText2.default, { message: message })
    );
  },
  renderFooter: function renderFooter() {
    return _react2.default.createElement(_MessageFooter2.default, {
      className: 'm-top-1',
      messageRole: this.props.messageRole,
      currentRole: this.props.currentRole,
      isLastInGroup: this.props.isLastInGroup,
      showFooterContent: this.props.showFooterContent,
      message: this.props.message,
      nextMessage: this.props.nextMessage,
      coloring: this.props.coloring,
      publishMessage: this.props.publishMessage,
      republishMessage: this.props.republishMessage,
      hideLabels: this.props.hideLabels,
      quickReplyDisabled: this.props.quickReplyDisabled,
      responder: this.props.responder
    });
  },
  render: function render() {
    return _react2.default.createElement(
      _MessageWrapper2.default,
      {
        footer: this.renderFooter(),
        avatar: this.renderAvatar(),
        isOwnMessage: this.isOwnMessage(),
        isAdmin: false,
        isLastInGroup: this.props.isLastInGroup
      },
      this.renderChatBubble()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/VisitorChatMessage.js
// module id = 1118
// module chunks = 2 3